import { render, staticRenderFns } from "./DetailFilters.vue?vue&type=template&id=1367b1ac&"
import script from "./DetailFilters.vue?vue&type=script&lang=js&"
export * from "./DetailFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/jobs/Applications/jobs/WebApps/jobs/dpr-field-calendar/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCombobox,VFlex,VLayout,VSelect,VTextField})
